import alertGeneral from '@/store/modules/alert/general';

export default {
  alertGeneral,
};
